import { ResponseHandler } from "@king-ict/eupisi-ui/components";
import "./App.css";
import { useKeycloak } from "@king-ict/eupisi-ui/hooks";

import Layout from "../features/Layout";
import { webUserPortalAplicationUrl } from "../routes/routes";
import Routing from "../routes/Routing";

function App() {
  const { keycloak } = useKeycloak();

  if (!keycloak.authenticated) {
    window.location.href = `${webUserPortalAplicationUrl}`;
  }

  require("../variablesImpared.scss");
  return (
    <>
    { keycloak.authenticated &&
      <Layout>
        <ResponseHandler />
        <Routing />
      </Layout>
    }
    </>
  );
}

export default App;
